/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Style_Guide_Manager_Enable_Guide_AriaInputs */



/**
* | output |
* | --- |
* | "Enable {name}" |
*
* @param {Style_Guide_Manager_Enable_Guide_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_enable_guide_aria = /** @type {((inputs: Style_Guide_Manager_Enable_Guide_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Enable_Guide_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Activer ${i?.name}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name} aktivieren`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Abilita ${i?.name}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Включить ${i?.name}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Habilitar ${i?.name}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`启用${i?.name}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.name} を有効にする`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.name} को सक्षम करें`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Ativar ${i?.name}`)
	return /** @type {LocalizedString} */ (`Enable ${i?.name}`)
});